export default [{
    path: "eventAudit",
    name: "eventAudit",
    component: () =>
      import ("@/views/eventManagement/eventAudit.vue"),
    meta: {
      title: "事件审核"
    }
  },
  {
    path: "eventRecord",
    name: "eventRecord",
    component: () =>
      import ("@/views/eventManagement/eventRecord.vue"),
    meta: {
      title: "事件记录"
    }
  },
  {
    path: "eventDispatch",
    name: "eventDispatch",
    component: () =>
      import ("@/views/eventManagement/eventDispatch.vue"),
    meta: {
      title: "事件分派"
    }
  },
  {
    path: "eventReport",
    name: "eventReport",
    component: () =>
      import ("@/views/eventManagement/eventReport.vue"),
    meta: {
      title: "事件分派"
    }
  }
];